import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext, useState } from 'react';
import { FormattedDate } from 'react-intl';
import { useQuery } from 'react-query';
import Rating from 'react-rating';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { useFormState } from 'react-use-form-state';
import { Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Heading, Button, Input, FormLabel, Textarea, Flex, Box, useToast } from '@chakra-ui/react';
import Spinner, { SpinnerContainer } from '@interness/web-core/src/components/modules/Spinner/Spinner';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import { EApiContext } from '../../context/EApi';
import Error from '../Error/Error';
import * as S from './styles';
import RatingStars from './RatingStars';
import { jsx as ___EmotionJSX } from "@emotion/react";
const ProductRatings = _ref => {
  let {
    productId
  } = _ref;
  const toast = useToast();
  const {
    fetchProductRatings,
    createProductRating
  } = useContext(EApiContext);
  const {
    0: currentRating,
    1: setCurrentRating
  } = useState(5);
  const {
    0: loading,
    1: setLoading
  } = useState(false);
  const [formState, {
    email,
    label,
    text,
    textarea
  }] = useFormState({}, {
    withIds: true
  });
  const {
    isIdle,
    isLoading,
    isError,
    data
  } = useQuery(['product_rating', {
    id: productId
  }], fetchProductRatings, {
    refetchOnWindowFocus: false,
    cacheTime: 'Infinity',
    staleTime: 'Infinity'
  });
  const onRate = async () => {
    setLoading(true);
    const rating = _objectSpread(_objectSpread({}, formState.values), {}, {
      product: productId,
      rating: currentRating
    });
    const res = await createProductRating(rating);
    if (!res.error) {
      formState.reset();
      setCurrentRating(5);
      setLoading(false);
      toast({
        title: 'Bewertung erfolgreich abgegeben.',
        description: 'Warten auf Freigabe',
        status: 'success',
        isClosable: true
      });
    } else {
      setLoading(false);
      toast({
        title: 'Bewertung konnte nicht gespeichert werden.',
        description: 'Bitte versuchen Sie es später erneut',
        status: 'error',
        isClosable: true
      });
    }
  };
  const onChangeRating = newRating => {
    setCurrentRating(newRating);
  };
  if (isIdle || isLoading) {
    return ___EmotionJSX(SpinnerContainer, null, ___EmotionJSX(Spinner, null));
  }
  if (isError) {
    return ___EmotionJSX(Error, null, "Bewertungen konnten nicht geladen werden");
  }
  const ratings = data.data;
  return ___EmotionJSX("div", null, ratings.length === 0 && ___EmotionJSX(Heading, {
    as: "h3",
    size: "lg"
  }, "Noch keine Bewertungen"), ratings.length === 1 && ___EmotionJSX(Heading, {
    as: "h3",
    size: "lg"
  }, "Eine Bewertung"), ratings.length >= 2 && ___EmotionJSX(Heading, {
    as: "h3",
    size: "lg"
  }, ratings.length, " Bewertungen"), ___EmotionJSX(Spacer, {
    height: 20
  }), ratings.length !== 0 && ___EmotionJSX(Accordion, {
    allowToggle: true
  }, ratings.map(rating => ___EmotionJSX(AccordionItem, {
    key: rating.id
  }, ___EmotionJSX("h4", null, ___EmotionJSX(AccordionButton, null, ___EmotionJSX(Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    w: "100%"
  }, ___EmotionJSX(Box, {
    textAlign: "left"
  }, ___EmotionJSX("i", null, ___EmotionJSX(FormattedDate, {
    value: rating.created_on,
    hour12: false,
    year: "numeric",
    month: "long",
    day: "2-digit"
  })), ___EmotionJSX("br", null), ___EmotionJSX("b", null, rating.name)), ___EmotionJSX(Box, {
    alignSelf: "flex-end"
  }, ___EmotionJSX(RatingStars, {
    rating: rating.rating
  }), ___EmotionJSX(AccordionIcon, null))))), ___EmotionJSX(AccordionPanel, null, rating.comment ? ___EmotionJSX("p", null, rating.comment) : ___EmotionJSX("i", null, "Kein Kommentar abgegeben."))))), ___EmotionJSX(Spacer, null), ___EmotionJSX(Heading, {
    as: "h4",
    size: "md"
  }, "Bewertung abgeben"), ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX("div", null, ___EmotionJSX(FormLabel, null, "Bewertung*"), ___EmotionJSX(S.Stars, null, ___EmotionJSX(Rating, {
    initialRating: currentRating,
    emptySymbol: ___EmotionJSX(FaRegStar, null),
    fullSymbol: ___EmotionJSX(FaStar, null),
    onChange: onChangeRating
  })), ___EmotionJSX(Flex, {
    flexWrap: "wrap",
    justifyContent: "space-between"
  }, ___EmotionJSX(Box, {
    width: {
      base: '100%',
      lg: '48%'
    },
    my: 5
  }, ___EmotionJSX(FormLabel, label('name'), "Name*"), ___EmotionJSX(Input, _extends({}, text('name'), {
    variant: "filled",
    isRequired: true
  }))), ___EmotionJSX(Box, {
    width: {
      base: '100%',
      lg: '48%'
    },
    my: 5
  }, ___EmotionJSX(FormLabel, label('email'), "E-Mail*"), ___EmotionJSX(Input, _extends({}, email('email'), {
    variant: "filled",
    isRequired: true
  }))), ___EmotionJSX(Box, {
    w: "100%",
    mt: 5
  }, ___EmotionJSX(FormLabel, label('comment'), "Kommentar"), ___EmotionJSX(Textarea, _extends({}, textarea('comment'), {
    variant: "filled",
    rows: 4
  })))), ___EmotionJSX(Box, {
    textAlign: "right"
  }, ___EmotionJSX(Button, {
    colorScheme: "brand",
    size: "sm",
    onClick: onRate,
    isLoading: loading,
    isDisabled: !formState.values.name || !formState.values.email,
    mt: 10
  }, "Bewertung abgeben"))));
};
export default ProductRatings;